import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { dateTimeSort } from '../../../../components/Util/oders';
import { useMemberships } from '../../../../../hooks/useMemberships';
import { rigaRichiesta } from './riga';

// Valori dei filtri a chip, come compaiono nella lista (le richieste confermate non ci sono).
const RUOLO_OPTIONS = ['Socio', 'Staff tecnico', 'Cda'];
const TIPOLOGIA_OPTIONS = ['Ricevuta', 'Inviata'];
const STATO_OPTIONS = ['In attesa', 'Rifiutata'];

export const StrutturaRichieste = () => {

	const navigate = useNavigate();

	const data_column = [
		{
			Header: 'Data richiesta',
			accessor: 'date',
			disableGlobalFilter: true,
			sortType: dateTimeSort,
		},
		{
			Header: 'Richiedente',
			accessor: 'name',
			Cell: ({ row }) => (
				<div style={{ display: 'flex', alignItems: 'center' }}>
				  <img
					src={row.original.imageUrl ? row.original.imageUrl : DEFAULT_USER}
					alt={row.original.name}
					style={{
					  width: '40px',
					  height: '40px',
					  borderRadius: '50%',
					  marginRight: '10px'
					}}
				  />
				  {row.original.name}
				</div>
			)
		},
		{
			Header: 'Ruolo',
			accessor: 'type',
			disableGlobalFilter: true,
		},
		{
			Header: 'Sport',
			accessor: 'sport',
		},
		{
			Header: 'Tipologia',
			accessor: 'verso',
			disableGlobalFilter: true,
		},
		{
			Header: 'Stato richiesta',
			id: 'status',
			accessor: row => row.status?.label,
			disableGlobalFilter: true,
			Cell: ({ row }) => {
				const value = row.original.status;
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
			disableFilters: true,
		},
	];

	const [data_json, setDataJson] = useState(null);
	// Chip a scelta multipla: all'inizio tutti accesi
	const [ruoloFilter, setRuoloFilter] = useState(RUOLO_OPTIONS);
	const [tipologiaFilter, setTipologiaFilter] = useState(TIPOLOGIA_OPTIONS);
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) =>
					// Un ruolo o uno stato fuori dai chip (o vuoto) resta sempre visibile
					(!RUOLO_OPTIONS.includes(row.type) || ruoloFilter.includes(row.type)) &&
					filtroMultiplo(tipologiaFilter, TIPOLOGIA_OPTIONS, row.verso) &&
					(!STATO_OPTIONS.includes(row.status?.label) || statoFilter.includes(row.status?.label)),
			),
		[data_json, ruoloFilter, tipologiaFilter, statoFilter],
	);
	const { memberships } = useMemberships({ autoFetch: true });

	useEffect(() => {
		if (memberships) {
			setDataJson(memberships.filter(element => element.status !== 'CONFIRMED').map(rigaRichiesta));
		}
	}, [memberships]);

	// La riga apre la scheda della richiesta: «Reinvia», «Accetta», «Rifiuta» e «Cancella» stanno lì (03/10/2026)
	const apriRichiesta = (row) => navigate('/struttura/richieste/' + row.id, { state: { richiesta: row } });

	return (
		<>
			<TabellaLista
				pageList={true}
				cardTitle={'Richieste'}
				hasSearch={true}
				searchPlaceholder={'Cerca per richiedente o sport'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Ruolo" options={RUOLO_OPTIONS} value={ruoloFilter} onChange={setRuoloFilter} multiple />
						<ChipFilter label="Tipologia" options={TIPOLOGIA_OPTIONS} value={tipologiaFilter} onChange={setTipologiaFilter} multiple />
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				hasAddMore={false}
				data_column={data_column}
				data_json={filteredData}
				openColumn={'name'}
				openRow={(row) => apriRichiesta(row)}
				sort_by={'date'}
                sort_type={'desc'}
			/>
		</>
	)

}
export default StrutturaRichieste;
